__turbopack_context__.v({
  "card": "style-module-scss-module__nzUkaa__card",
  "cardNumber": "style-module-scss-module__nzUkaa__cardNumber",
  "cardTitle": "style-module-scss-module__nzUkaa__cardTitle",
  "cards": "style-module-scss-module__nzUkaa__cards",
  "chub": "style-module-scss-module__nzUkaa__chub",
  "chub1": "style-module-scss-module__nzUkaa__chub1",
  "chub2": "style-module-scss-module__nzUkaa__chub2",
  "chub3": "style-module-scss-module__nzUkaa__chub3",
  "content": "style-module-scss-module__nzUkaa__content",
  "title": "style-module-scss-module__nzUkaa__title",
  "wrapper": "style-module-scss-module__nzUkaa__wrapper",
});
